module.exports = __webpack_public_path__ + "img/team-bramfeldersv.457e0448.jpg";